import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20toned%20warehouse%20or%20logistics%20center%20interior%20with%20organized%20shelves%20of%20packages%20and%20boxes%2C%20soft%20ambient%20lighting%2C%20cream%20and%20beige%20color%20palette%2C%20clean%20and%20minimal%20aesthetic%2C%20atmospheric%20industrial%20photography%20with%20gentle%20shadows%2C%20professional%20editorial%20style&width=1600&height=900&seq=cta-bg-yoybuy&orientation=landscape"
        alt="YOYBUY Sheet - CTA"
        title="YOYBUY Sheet CTA фоновое изображение"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-bold leading-tight mb-4 tracking-wide">
          {t('ctaTitle')}
        </h2>
        <p className="text-background-50/75 text-sm md:text-base font-body mb-10 max-w-xl mx-auto leading-relaxed">
          {t('ctaSubtitle')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full text-sm font-label font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 shrink-0">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </span>
          <span>{t('ctaButton')}</span>
          <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300">
            <i className="ri-arrow-right-up-line text-background-50 text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}